(() => {
  const FONT_TIMEOUT = 4500;

  const init = (root) => {
    const select = root.querySelector('[data-uf-font-select]');
    const cards = [...root.querySelectorAll('[data-uf-font-card]')];
    const designer = root.querySelector('[data-uf-designer]');
    if (!select || !designer || !cards.length || root.dataset.ufFonts703Ready === 'true') return;
    root.dataset.ufFonts703Ready = 'true';

    const status = document.createElement('p');
    status.className = 'uf-font-reliability-status';
    status.setAttribute('aria-live', 'polite');
    status.textContent = 'Loading engraving fonts…';
    root.querySelector('[data-uf-font-picker]')?.append(status);

    const names = cards
      .map((card) => card.dataset.fontName)
      .filter((name) => name && name !== 'Other font requested');

    const applyCardFamilies = () => {
      cards.forEach((card) => {
        const name = card.dataset.fontName;
        if (!name || name === 'Other font requested') return;
        card.style.setProperty('--uf-font-family', `"${name}"`);
      });
    };

    const waitForFonts = async () => {
      if (!document.fonts?.load) {
        status.textContent = 'Font preview is using browser-compatible fallbacks.';
        return;
      }
      applyCardFamilies();
      const timer = new Promise((resolve) => setTimeout(resolve, FONT_TIMEOUT, 'timeout'));
      const loads = Promise.allSettled(names.map((name) => document.fonts.load(`32px "${name}"`, 'Aa')));
      const result = await Promise.race([loads, timer]);
      if (result === 'timeout') {
        status.textContent = 'Some fonts are still loading. Your selected font will apply automatically.';
      } else {
        status.textContent = 'Engraving fonts loaded and ready.';
        root.dataset.ufFontsLoaded = 'true';
        designer.dispatchEvent(new CustomEvent('uf:fonts-ready', { bubbles: true }));
      }
    };

    select.addEventListener('change', async () => {
      const name = select.value;
      if (!name || name === 'Other font requested' || !document.fonts?.load) return;
      status.textContent = `Loading ${name}…`;
      try {
        await document.fonts.load(`32px "${name}"`, 'Uniq Flair');
        status.textContent = `${name} is ready.`;
      } catch (error) {
        status.textContent = `${name} could not be verified. A safe fallback will be used.`;
      }
    });

    waitForFonts();
  };

  const boot = () => document.querySelectorAll('[data-uf-personalization-side]').forEach(init);
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
